import React, { useState, useEffect } from 'react'
import Axios from 'axios'

export function Filter({
  title,
  placeholder,
  count,
  mode,
  defaultSearchText,
  isOpen,
  onClick,
  onSearch,
  onClearSearch,
  inputDataAnalytics,
}) {
  const [searchText, setSearchText] = useState('')
  const [autoCompleteData, setAutoCompleteData] = useState([])
  const [autoCompleteActive, setAutoCompleteActive] = useState(false)
  const [autoCompleteIndex, setAutoCompleteIndex] = useState(-1)

  const [isFilterOpen, setIsFilterOpen] = useState(false)

  useEffect(() => {
    if (typeof defaultSearchText === 'string') {
      setSearchText(defaultSearchText)
    }
  }, [defaultSearchText])

  useEffect(() => {
    if (isOpen) {
      setIsFilterOpen(true)
    } else {
      setIsFilterOpen(false)
    }
  }, [isOpen])

  useEffect(() => {
    const source = Axios.CancelToken.source()

    const getSearchSuggestions = async () => {
      try {
        if (searchText.trim().length > 2 && searchText.split(' ').length < 2) {
          const url = `/api/cti-inst/autocomplete/${searchText}?count=5&field=text`

          const response = await Axios.get(url, {
            cancelToken: source.token,
          })

          setAutoCompleteData(response.data)
        } else {
          setAutoCompleteData([])
          setAutoCompleteActive(false)
        }
      } catch (error) {
        if (Axios.isCancel(error)) {
          return
        } else {
          throw error
        }
      }
    }

    if (defaultSearchText !== searchText) {
      getSearchSuggestions()
    }

    setAutoCompleteActive(true)

    return () => {
      source.cancel()
    }
  }, [searchText])

  const onChangeSearch = (event) => {
    setSearchText(event.currentTarget.value)

    if (!mode || mode.indexOf('on-key-press') >= 0) {
      onSearch && onSearch(event)
    }
  }

  const onKeyUpSearch = (event) => {
    // UP ARROW
    if (event.keyCode === 38) {
      if (autoCompleteIndex === 0) {
        return
      }

      setAutoCompleteIndex(autoCompleteIndex - 1)
    }
    // DOWN ARROW
    else if (event.keyCode === 40) {
      if (autoCompleteIndex + 1 === autoCompleteData.length) {
        return
      }

      setAutoCompleteIndex(autoCompleteIndex + 1)
    }
    // ENTER
    else if (
      mode &&
      mode.indexOf('on-key-enter') >= 0 &&
      event.keyCode === 13
    ) {
      setAutoCompleteActive(false)

      if (searchText.length > 2 && autoCompleteData.length > 0) {
        setAutoCompleteIndex(-1)
        setAutoCompleteData([])

        const e = {
          currentTarget: {
            value:
              autoCompleteData[autoCompleteIndex] || event.currentTarget.value,
          },
        }

        onSearch && onSearch(e)
      } else {
        onSearch && onSearch(event)
      }
    }
  }

  const onClickAutoCompItem = (item) => {
    setAutoCompleteIndex(-1)
    setAutoCompleteData([])

    const event = {
      currentTarget: {
        value: item,
      },
    }

    onSearch && onSearch(event)
  }

  const onClickToggleFilter = (event) => {
    setIsFilterOpen(!isFilterOpen)

    onClick && onClick(event)
  }

  const onClickSearch = () => {
    setAutoCompleteIndex(-1)
    setAutoCompleteData([])

    const event = {
      currentTarget: {
        value: searchText,
      },
    }

    onSearch && onSearch(event)
  }

  const onClickClearSearch = (event) => {
    setSearchText('')
    setAutoCompleteIndex(-1)
    setAutoCompleteData([])

    onClearSearch && onClearSearch(event)
  }

  return (
    <>
      <div className="u-flex u-sm-flexColReverse u-flexAlignItemsCenter u-sm-flexAlignItemsStretch">
        {onClick && (
          <button
            className="Button u-posRelative u-flex u-flexAlignItemsCenter u-flexAuto u-md-size1of2 u-lg-size1of2 u-paddingVert1gu u-sm-paddingVert3gu u-textLeft"
            onClick={onClickToggleFilter}
          >
            <div
              className={
                'u-textSizeMsrp5 MutualFunds-filterButton ' +
                (isFilterOpen
                  ? 'MutualFunds-filterButtonOpen'
                  : 'MutualFunds-filterButtonClosed')
              }
            >
              {isFilterOpen ? '-' : '+'}
            </div>
            <div className="u-textSecondary u-textSizeMsrp2 u-paddingLeft3gu u-textBold">
              {title || 'Filters'}
            </div>
            <div className="u-textSizeMsrp2 u-marginLeft2gu">
              ({count} applied)
            </div>
          </button>
        )}
        <div
          className={`u-flex u-flexAlignItemsCenter u-flexAuto u-md-size1of2 u-lg-size1of2 u-bgColorWhite ${
            onClick ? 'u-paddingLeft4gu u-sm-paddingLeft0' : ''
          }`}
        >
          <div className="u-posRelative u-flexAuto u-paddingBottom2gu">
            <span
              className={`Icon--material u-textColorBrand u-posAbsolute ${
                mode?.indexOf('large-icon') >= 0
                  ? 'u-sm-textSizeMsrp2 u-md-textSizeMsrp3 u-lg-textSizeMsrp4'
                  : 'u-sm-textSizeMsrp1 u-md-textSizeMsrp2 u-lg-textSizeMsrp2'
              }`}
              style={
                mode?.indexOf('large-icon') >= 0
                  ? { top: '15%' }
                  : { bottom: '16px' }
              }
              aria-hidden="true"
            >
              search
            </span>
            <input
              type="text"
              data-analytics={inputDataAnalytics}
              placeholder={placeholder}
              className={`Input u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0 ${
                mode?.indexOf('large-icon') >= 0
                  ? 'u-paddingLeft12gu u-paddingRight12gu u-paddingBottom0 u-sm-textSizeMsrp1 u-md-textSizeMsrp2 u-lg-textSizeMsrp3'
                  : 'u-paddingLeft6gu u-paddingRight6gu u-paddingBottom1gu'
              }`}
              value={searchText}
              onChange={onChangeSearch}
              onKeyUp={onKeyUpSearch}
            />
            {onClearSearch && (
              <div
                id={'clearSearch'}
                className="u-posAbsolute"
                style={{
                  cursor: 'pointer',
                  top: mode?.indexOf('large-icon') >= 0 ? '15%' : null,
                  bottom: mode?.indexOf('large-icon') >= 0 ? null : 10,
                  right: 0,
                }}
                onClick={onClickClearSearch}
              >
                <span
                  id="cti-navigation-search-clear"
                  className={`Icon--material u-textColorLight ${
                    mode?.indexOf('large-icon') >= 0
                      ? 'u-sm-textSizeMsrp2 u-md-textSizeMsrp3 u-lg-textSizeMsrp4'
                      : 'u-sm-textSizeMsrp1 u-md-textSizeMsrp2 u-lg-textSizeMsrp3'
                  }`}
                  aria-hidden="true"
                >
                  close
                </span>
              </div>
            )}
          </div>
          {mode && mode.indexOf('submit-button') >= 0 && (
            <div>
              <input
                type="submit"
                className="Button Button--secondary u-textNoWrap u-textUppercase u-marginLeft3gu u-paddingHoriz8gu"
                value="Search"
                data-qa-automation="search-button"
                onClick={onClickSearch}
              />
            </div>
          )}
        </div>
      </div>
      {autoCompleteData &&
        autoCompleteActive &&
        autoCompleteData.length > 0 && (
          <div className="dropdown u-bgColorWhite u-sizeConstrained">
            {autoCompleteData.map((item, index) => {
              return (
                <div
                  key={item}
                  className={`auto-complete-suggestion -inst u-paddingVert1gu u-paddingLeft8gu u-size1of2 u-textSizeMsrp2 ${
                    index === autoCompleteIndex
                      ? 'u-bgColorBrandDark u-textColorWhite'
                      : ''
                  }`}
                  onClick={() => onClickAutoCompItem(item)}
                >
                  {item}
                </div>
              )
            })}
          </div>
        )}
    </>
  )
}
